const DOMAIN_TYPOS: Record<string, string> = {
  // mail.ru
  'mial.ru': 'mail.ru',
  'maul.ru': 'mail.ru',
  'mai.ru': 'mail.ru',
  'mail.r': 'mail.ru',
  'maill.ru': 'mail.ru',
  'mal.ru': 'mail.ru',
  'amil.ru': 'mail.ru',
  // gmail.com
  'gmial.com': 'gmail.com',
  'gmal.com': 'gmail.com',
  'gmaill.com': 'gmail.com',
  'gmail.co': 'gmail.com',
  'gmail.ru': 'gmail.com',
  'gamil.com': 'gmail.com',
  'gnail.com': 'gmail.com',
  'gmai.com': 'gmail.com',
  // yandex.ru
  'yandes.ru': 'yandex.ru',
  'yanex.ru': 'yandex.ru',
  'yadex.ru': 'yandex.ru',
  'yandx.ru': 'yandex.ru',
  'yandex.r': 'yandex.ru',
  'yndex.ru': 'yandex.ru',
  // outlook.com
  'outloo.com': 'outlook.com',
  'outlok.com': 'outlook.com',
  'outllok.com': 'outlook.com',
  // rambler.ru
  'rambller.ru': 'rambler.ru',
  'ramber.ru': 'rambler.ru',
  'ramblet.ru': 'rambler.ru',
  // bk.ru
  'bk.r': 'bk.ru',
  // list.ru
  'lis.ru': 'list.ru',
  'liist.ru': 'list.ru',
  // inbox.ru
  'inbx.ru': 'inbox.ru',
  'inox.ru': 'inbox.ru',
};

/**
 * Returns the suggested corrected email if a typo is detected, or null.
 * Example: checkEmailTypo('user@mial.ru') => 'user@mail.ru'
 */
export function checkEmailTypo(email: string): string | null {
  if (!email || !email.includes('@')) return null;

  const [user, domain] = email.split('@');
  if (!user || !domain) return null;

  const lowerDomain = domain.toLowerCase();
  const suggestion = DOMAIN_TYPOS[lowerDomain];

  if (suggestion) {
    return `${user}@${suggestion}`;
  }

  return null;
}
